module.exports = __webpack_public_path__ + "img/23.968314cb.png";